module.exports = __webpack_public_path__ + "img/green_060.ceb7798c.png";